/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface CoinsVolumeLeadersResponseDataInner
 */
export interface CoinsVolumeLeadersResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof CoinsVolumeLeadersResponseDataInner
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof CoinsVolumeLeadersResponseDataInner
     */
    volume: number;
    /**
     * 
     * @type {User}
     * @memberof CoinsVolumeLeadersResponseDataInner
     */
    user?: User;
}

/**
 * Check if a given object implements the CoinsVolumeLeadersResponseDataInner interface.
 */
export function instanceOfCoinsVolumeLeadersResponseDataInner(value: object): value is CoinsVolumeLeadersResponseDataInner {
    let isInstance = true;
    isInstance = isInstance && "address" in value && value["address"] !== undefined;
    isInstance = isInstance && "volume" in value && value["volume"] !== undefined;

    return isInstance;
}

export function CoinsVolumeLeadersResponseDataInnerFromJSON(json: any): CoinsVolumeLeadersResponseDataInner {
    return CoinsVolumeLeadersResponseDataInnerFromJSONTyped(json, false);
}

export function CoinsVolumeLeadersResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoinsVolumeLeadersResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'volume': json['volume'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
    };
}

export function CoinsVolumeLeadersResponseDataInnerToJSON(value?: CoinsVolumeLeadersResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'volume': value.volume,
        'user': UserToJSON(value.user),
    };
}

